<template>
  <div class="donation">
    <div class="card">
      <h1>{{campaign.title}}</h1>
      <p>{{campaign.description}}</p>
      <table>
        <tr>
          <th>Organisatie</th>
          <td>{{campaign.organization.name}}</td>
        </tr>
        <tr>
          <th>IBAN</th>
          <td>{{campaign.organization.iban}}</td>
        </tr>
        <tr>
          <th>Onderwerp</th>
          <td>{{campaign.tikkie_subject}}</td>
        </tr>
        <tr v-if="campaign.donation_min_price">
          <th>Min. bedrag</th>
          <td>{{donation_min_price}}</td>
        </tr>
      </table>
      <ul class="options" v-if="campaign.donation_options && campaign.donation_options.length > 0">
        <li
          :key="opt.id"
          v-for="opt in campaign.donation_options"
          @click="select_option(opt)"
          :class="get_option_class(opt)"
        >
          {{ format(opt.price_incl_vat, opt.currency) }}
        </li>
      </ul>
      <div  v-if="!campaign.donation_hide_input">
        <div class="amount-text-field">{{campaign.donation_other_amount_text}}</div>
        <div class="amount">
          <input
            type="number"
            onfocus="this.oldValue = this.value; this.value = ''"
            onblur="if (!this.value) { this.value = this.oldValue; }"
            @change="convert_amount"
            v-model="amount"
          />
          </div>
      </div>
<!--      <div v-if="allows_anonymous" @click="() => {anon = !anon}" class="c-checkmark">-->
<!--        <label class="box">Ik wil anoniem doneren-->
<!--          <span v-if="anon" class="checkmark">✓</span>-->
<!--          <span v-else class="checkbox"></span>-->
<!--        </label>-->
<!--      </div>-->
      <!-- <div @click="() => { anon = !anon }" class="c-checkmark">
        <label class="box">Ik wil anoniem doneren
          <span v-if="anon" class="checkmark">✓</span>
          <span v-else class="checkbox"></span>
        </label>
      </div> -->
    </div>
    <bottom-button state="payment" @clicked="submit" :amount="order.campaign.price_incl_vat"/>
  </div>
</template>

<script>
import cn from 'classnames';
import BottomButton from './Bottom-Button.vue';

export default {
  name: 'Donation',
  components: {
    BottomButton,
  },
  computed: {
    campaign() {
      return this.$store.getters['application/getCampaign'];
    },
    order() {
      return this.$store.getters['application/getOrder'];
    },
    allows_anonymous() {
      return this.campaign.donation_allow_anonymous;
    },
    donation_min_price() {
      return this.format(this.campaign.donation_min_price);
    },
  },
  data() {
    return {
      amount: '',
      anon: false,
    };
  },
  mounted() {
    if (this.order.campaign.price_incl_vat !== this.campaign.price_incl_vat) {
      this.amount = this.order.campaign.price_incl_vat / 100;
    } else if (this.campaign.price_incl_vat > 0) {
      this.amount = this.campaign.price_incl_vat / 100;
    }

    if (this.amount !== '') {
      this.convert_amount();
    }
  },
  methods: {
    submit() {
      if (!this.campaign.requires_address || this.anon) {
        this.$store.dispatch('application/postOrder', this.anon);
      } else {
        this.$router.push({ name: 'details' });
      }
    },
    convert_amount() {
      // Catch minimum donation amount
      let amount = Number(this.amount);
      if (amount < this.order.campaign.donation_min_price / 100) {
        amount = this.order.campaign.donation_min_price / 100;
      }

      this.order.campaign.price_incl_vat = Math.round(amount * 100);
      this.amount = amount.toFixed(2);
    },
    select_option(option) {
      this.amount = option.price_incl_vat / 100;
      this.convert_amount();
    },
    get_option_class(option) {
      return cn('options__option', {
        'options__option--active': (option.price_incl_vat / 100).toFixed(2) === this.amount,
      });
    },
    format(price, currency = 'EUR') {
      return (price / 100).toLocaleString('nl-NL', {
        style: 'currency',
        currency,
      });
    },
  },
};
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';

  .donation {
    h1 {
      margin-bottom: 0;
    }
    table {
      text-align: left;
      th {
        padding-right: 10px;
      }
    }

    .options {
      list-style: none;
      padding: 0;
      margin: 10px 0 -12px 0;
      display: flex;
      flex-wrap: wrap;

      &__option {
        font-weight: bold;
        display: block;
        padding: 5px 10px;
        color: $gray-dark;
        border: 2px solid $gray;
        margin-right: 8px;
        margin-bottom: 8px;
        cursor: pointer;

        &--active {
          border-color: $secondary-highlight;
          background-color: $secondary-highlight;
          color: white;
        }
      }
    }
    .amount-text-field {
      margin-top: 20px;
    }
    .amount {
      position: relative;
      text-align: center;
      /*margin-top: 20px;*/
      margin-bottom: -10px;
      padding: 5px 0;
      width: 100%;
      background-color: $gray + #222;
      font-size: 20pt;

      &::before {
        content: "€";
        position: absolute;
        left: 10px;
        width: 30px;
      }

      input {
        width: 100%;
        padding: 0 40px;
        text-align: center;
        background-color: $gray + #222;
        border: none;
        font-size: 20pt;
        &:focus {
          outline: none;
        }
      }
    }

    .c-checkmark {
      margin-top: 20px;

      label {
        margin-bottom: 0px;
      }
    }
  }
</style>
